// extracted by mini-css-extract-plugin
export var form = "ResetPasswordForm-module__form___Hhi1x";
export var heading = "ResetPasswordForm-module__heading___v8ks7";